import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Session/Login.vue'
import ChangePassword from '../views/Session/ChangePassword.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/login', component: Login,  meta: { requiresAuth: false } },
  { path: '/changepassword', component: ChangePassword,  meta: { requiresAuth: true } },

    
  { path: '/', component: (resolve) => {
      require.ensure(['../views/Dashboard/Index.vue'], () => {
        resolve(require('../views/Dashboard/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '*', component: (resolve) => {
      require.ensure(['../views/Error404.vue'], () => {
        resolve(require('../views/Error404.vue'))
      })
  },  meta: { requiresAuth: true } }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js